import productCacheService from '../components/IndexDB/productCacheService';
import customerCacheService from '../components/IndexDB/customerCacheService';

// Single place to wipe every identity-scoped client cache (IndexedDB product/
// customer catalogs). Call this on logout, forced logout, or session expiry —
// anywhere a different user/branch may start using this device next.
export default {
  async clearAll() {
    await Promise.all([
      productCacheService.clearCache(),
      customerCacheService.clearCache(),
    ]);
  },
};
